module.exports = "#admin-planned-actual-div {\r\n min-height: 85vh;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/planed-actual/planed-actual.component.css
// module id = ./src/app/admin/planed-actual/planed-actual.component.css
// module chunks = main